var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"}},[_c('div',{staticStyle:{"width":"80%","display":"flex","justify-content":"flex-start"}},[_c('img',{staticStyle:{"height":"42px"},attrs:{"src":"https://s3iconimages.mymedicine.com.mm/mymedLogo.svg","alt":""}})])])
}]

export { render, staticRenderFns }